import { type FuuzeQueryOptions, queryKeys, User, type UserDTO, useFuuzeQuery } from '@fuuze/shared';
import { getAuth } from 'firebase/auth';
import { fetchService } from '../singletons';

const transformRawDataToUser = (data: UserDTO) => new User(data);

/**
 * Hook to retrieve the user from the DB.
 * It is not placed in shared package because the enabled param depends on firebase user existence,
 * but web and mobile does not use the same package, se we can't share this hook for both platform
 */
export function useUser(options?: FuuzeQueryOptions<UserDTO, User>) {
  return useFuuzeQuery({
    ...options,
    staleTime: options?.staleTime || Number.POSITIVE_INFINITY,
    gcTime: options?.gcTime || Number.POSITIVE_INFINITY,
    queryKey: queryKeys.user.signIn(),
    queryFn: async () => fetchService.get<User>('/user/signIn'),
    select: transformRawDataToUser,
    enabled: !!getAuth().currentUser,
  });
}
